import Rioglyph from '@rio-cloud/rio-uikit/Rioglyph';
import { uniq } from 'es-toolkit';
import { FormattedMessage } from 'react-intl';
import { BulkStatusError, BulkStatusErrorMessage } from './BulkStatusErrorMessage';
import { ReactNode } from 'react';

type BulkUpdateValidationFeedbackProps = {
    readonly isSuccess: boolean;
    readonly validItemsCount: number;
    readonly invalidItems: readonly BulkStatusError[];
    readonly requestError?: ReactNode;
};

export const BulkUpdateValidationFeedback = ({
    isSuccess,
    requestError,
    validItemsCount,
    invalidItems,
}: BulkUpdateValidationFeedbackProps) => {
    const uniqueInvalidItemCount = uniq(invalidItems.flatMap((error) => error.identifiers)).length;
    const totalItemsCount = validItemsCount + uniqueInvalidItemCount;

    let feedback;
    if (requestError) {
        feedback = requestError;
    } else if (isSuccess && validItemsCount > 0) {
        feedback = (
            <>
                <div>
                    <FormattedMessage
                        id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.successCount"
                        values={{ successCount: validItemsCount, totalCount: totalItemsCount }}
                    />
                </div>
                {invalidItems.length > 0 && <BulkStatusErrorMessage errors={invalidItems} />}
            </>
        );
    } else {
        feedback = (
            <>
                <div>
                    <FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.failure" />
                </div>
                {invalidItems.length > 0 && <BulkStatusErrorMessage errors={invalidItems} />}
            </>
        );
    }

    const iconConfig = isSuccess
        ? { icon: 'rioglyph-check-badge', iconClassName: 'text-color-success' }
        : { icon: 'rioglyph-remove-sign', iconClassName: 'text-color-danger' };

    return (
        <div className="min-height-300 display-flex flex-column justify-content-center align-items-center gap-20">
            <div className="text-size-16">
                <FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.title" />
            </div>
            <div>
                <Rioglyph icon={iconConfig.icon} iconClassName={iconConfig.iconClassName} size="h1" />
            </div>
            {feedback}
        </div>
    );
};
